import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { catchError, finalize, tap } from 'rxjs/operators';
import { RegistrationService } from '../../../../shared/services/auth/registration.service';
import { AnalyticsFormService } from '../../../../core/services/analytics-form.service';
import { SavedUrlService } from '../../../../core/services/saved-url.service';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-step-phone',
  templateUrl: './step-phone.component.html',
  styleUrls: ['./step-phone.component.scss'],
})
export class StepPhoneComponent implements OnInit {
  @Input()
  formGroupName!: string;

  public stepForm!: FormGroup;
  public formName = 'phoneGroup';
  public loading = false;
  public errors: string[];
  public submitted = false;

  constructor(private formGroupDirective: FormGroupDirective, private registrationService: RegistrationService,
              private analyticsFormService: AnalyticsFormService, private saverUrlService: SavedUrlService) {
  }

  ngOnInit(): void {
    this.stepForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
  }

  get phone(): FormControl {
    return this.stepForm.get('phone') as FormControl;
  }

  public onSubmit() {
    this.loading = true;
    this.submitted = true;
    if (this.stepForm.invalid) {
      this.stepForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    const registerData = this.stepForm.value;

    this.registrationService
      .addPhone(registerData)
      .pipe(
        tap(() => this.saverUrlService.clear()),
        catchError((errors) => {
          this.errors = errors?.error?.errorCodes;
          this.phone.setErrors({ [errors]: true });
          this.analyticsFormService.sendEventForCaughtError('emailVerificationGroup', this.formName);
          return throwError(() => errors);
        }),
        finalize(() => {
          this.loading = false;
        }),
      ).subscribe();
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
